import AVAILABLE_ENVIRONMENTS from '../config';

export {
  AVAILABLE_ENVIRONMENTS as environments
};

export default {
  ...process.env,
  // tslint:disable-next-line: no-string-literal
  ...(AVAILABLE_ENVIRONMENTS['__RUNTIME_ENV__'] || AVAILABLE_ENVIRONMENTS.development)
};
